import {
  ToggleButton,
  ToggleButtonGroup,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const DateFormat = ({ buttonSx, selectedFilters, setSelectedFilters }) => {
  const { t } = useTranslation('bulk');
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <ToggleButtonGroup
      variant="outlined"
      fullWidth={smallScreen}
      color="primary"
      value={selectedFilters.dateFormat}
      onChange={e =>
        setSelectedFilters(state => ({
          ...state,
          dateFormat: e.target.value,
        }))
      }
      sx={{
        '.MuiToggleButtonGroup-grouped': {
          borderColor: theme.palette.divider,
        },
      }}
    >
      <ToggleButton sx={buttonSx} value="date">
        {t('dateOrdered')}
      </ToggleButton>
      <ToggleButton sx={buttonSx} value="completedOn">
        {t('completionDate')}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default DateFormat;
